import { inject, Injectable } from '@angular/core';
import { Router, UrlTree } from '@angular/router';
import { Store } from '@ngrx/store';
import { AuthGroupService } from 'apps/hospital-admin/src/app/auth-group/+state/auth-group.service';
import { InitializeAuthGroupSignal } from 'apps/hospital-admin/src/app/auth-group/+state/auth-group.signals';
import { AUTH_GROUPS } from 'apps/hospital-admin/src/app/auth-group/constants';
import { filter, first, map, Observable, switchMap } from 'rxjs';

export const REPORTING_ALLOWED_GROUPS = [
  AUTH_GROUPS.HOSPITAL_OFFICER,
  AUTH_GROUPS.RESTRICTED_HOSPITAL_OFFICER,
];

@Injectable({ providedIn: 'root' })
export class ReportingAuthGuardService {
  private authGroupService = inject(AuthGroupService);
  private router = inject(Router);
  private store = inject(Store);

  canActivate(): Observable<boolean | UrlTree> {
    this.store.dispatch(new InitializeAuthGroupSignal({}));
    return this.authGroupService.isLoaded().pipe(
      filter((isLoaded) => isLoaded),
      switchMap(() =>
        this.authGroupService.getOfficerBelongsToAnyOfTheAuthGroups(REPORTING_ALLOWED_GROUPS),
      ),
      first(),
      map((isAllowed) => (isAllowed ? true : this.router.parseUrl('/dashboard'))),
    );
  }
}
